// extracted by mini-css-extract-plugin
export default {"InputGroup":"InputGroup--lE69T","InputGroup--l":"InputGroup--l--BHXft"};